<template>
  <div id="app">
    <div class="row mx-0">
      <TheSidebar class="float-left mb-2" />
    </div>
    <router-view></router-view>
    <label class="text-white"> © {{ currentYear }} Σώμα Ελλήνων Προσκόπων Πτολεμαίων 1, 11635, Αθήνα | Τηλ: 2107290046 |
      Φάξ: 2107236561 | hello@sep.org.gr</label>

  </div>
</template>

<script>
import TheSidebar from './components/TheSidebar.vue'

const now = new Date();
const currentYear = now.getFullYear();
export default {
  name: 'app',
  components: {
    TheSidebar
  },
  props: {
    username: String,
  },
  data() {
    return {
      currentYear: currentYear
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
</style>

<style lang="scss">
@import '@/assets/sass/app.scss';
</style>
